module.exports = __webpack_public_path__ + "img/contact-phone.6e1118ae.svg";